import React, { useState } from 'react';
import { currencyUSD } from '../../../helpers/forms/formater';
import AddUpdModal from './AddUpdModal';
import DataTableElement from "../../../components/elements/DataTableElement";
import CustomButton from '../../../components/form/CustomButton';
import { useDispatch } from 'react-redux';
import { reset_load_payment, update_load_payment } from '../../../store/loadPayments/action';

const LoadConceptPayments = ({ load }) => {
    const dispatch = useDispatch()
    const [modal, setModal] = useState({ show: false });

    const [tableLoad, setTableLoad] = useState({
        show: false,
        textLoad: "Loading payments...",
    });

    const openModalAdd = (item) => {
        dispatch((item.id || item.local_id) ? update_load_payment(item) : reset_load_payment(item))
        setModal({ ...modal, show: true })
    }

    const onDelete = (item) => {
        const payments = load.values.payments || [];
        const updated = payments.filter(
            p => p.local_id !== item.local_id
        );
        load.setFieldValue('payments', updated);
    };

    const cols = [
        {
            id: "concept",
            name: "concept",
            selector: (row) => `${row.concept}`,
        },
        {
            id: "amount",
            name: "amount",
            selector: (row) => `${currencyUSD(row.amount)}`,
        },
        {
            id: "actionsPayments",
            name: "",
            selector: (row) => {
                return (
                    <div className="flex flex-col space-y-2">
                        {/* Fila inferior - editar y eliminar */}
                        <div className="flex items-center space-x-2">
                            <button type='button' onClick={() => openModalAdd(row)} className="flex items-center justify-center px-4 py-2 border-r hover:bg-gray-100">
                                <i className="fas fa-pen text-gray-500"></i>
                            </button>
                            <button type='button' onClick={() => onDelete(row)} className={`flex items-center justify-center px-4 py-2 hover:bg-gray-100`}>
                                <i className={`fas fa-trash text-red-500`}></i>
                            </button>
                        </div>
                    </div>
                )
            },
        },
    ];
    const totalAmount = (load.values.payments || [])
        .reduce((sum, p) => sum + Number(p.amount || 0), 0);

    return (
        <div className="load-concept-payments space-y-3">
            {/* Header */}
            <div className="flex items-center justify-between">
                <div>
                    <div className="text-xs text-cs-muted">
                        Payment concepts
                    </div>
                    <div className="font-semibold text-cs-dark">
                        Total load: {currencyUSD(totalAmount)}
                    </div>
                </div>

                <CustomButton
                    onClick={() => openModalAdd({})}
                    className="inline-flex items-center gap-1"
                >
                    <span className="material-symbols-outlined text-sm">add</span>
                    Add payment concept
                </CustomButton>
            </div>

            {/* Table */}
            <div className="payments-container">
                <DataTableElement
                    columns={cols}
                    items={load.values.payments}
                    tableLoad={tableLoad}
                />
            </div>

            {modal.show && (
                <AddUpdModal load={load} modal={modal} setModal={setModal} />
            )}
        </div>
    );
}

export default LoadConceptPayments